import React, { useEffect, useState } from 'react'
import { createPortal } from 'react-dom'

const TOP_HEADER_ACTIONS_SLOT_ID = 'reports-page-top-header-actions'

type ReportPageHeaderProps = {
  /**
   * @deprecated The page title is now rendered by the top header in
   * `Reports.page.tsx` (derived from the current route). This prop is kept
   * for backward compatibility but is no longer rendered here.
   */
  title?: string
  children?: React.ReactNode
}

/**
 * Renders the per-report action buttons into the global reports top header
 * (`#reports-page-top-header-actions`). Returns `null` locally because the
 * page title and the actions both live in the top header now.
 */
function ReportPageHeader({
  children,
}: ReportPageHeaderProps): React.ReactElement | null {
  const [slot, setSlot] = useState<HTMLElement | null>(null)

  useEffect(() => {
    setSlot(document.getElementById(TOP_HEADER_ACTIONS_SLOT_ID))
  }, [])

  if (!slot || children == null) return null
  return createPortal(<>{children}</>, slot)
}

export default ReportPageHeader
